import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import o from "../Graphic.js";
import "../core/Logger.js";
import { ensureType as e } from "../core/accessorSupport/ensureType.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/set.js";
import { shared as s } from "../core/accessorSupport/decorators/shared.js";
import { subclass as t } from "../core/accessorSupport/decorators/subclass.js";
import { OwningCollection as p } from "../core/support/OwningCollection.js";

var c = /*#__PURE__*/function (_p) {
  _inherits(c, _p);

  var _super = _createSuper(c);

  function c() {
    _classCallCheck(this, c);

    return _super.apply(this, arguments);
  }

  _createClass(c, [{
    key: "_own",
    value: function _own(r) {
      r.layer && "remove" in r.layer && r.layer !== this.owner && r.layer.remove(r), r.layer = this.owner;
    }
  }, {
    key: "_release",
    value: function _release(r) {
      r.layer === this.owner && (r.layer = null);
    }
  }]);

  return c;
}(p);

r([s({
  Type: o,
  ensureType: e(o)
})], c.prototype, "itemType", void 0), c = r([t("esri.support.GraphicsCollection")], c);
export { c as GraphicsCollection };